import React from 'react';
import {createPortal} from "react-dom";
import Ringer from "./CallScreen/Ringer.tsx";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@store/store.tsx";
import {endCall, generateCallToken, setCall} from "@store/callSlice.tsx";
import CallScreen from "./CallScreen";

const CallHandler = (props: any) => {
    const [ring, setRing] = React.useState(false)
    const dispatch = useDispatch<AppDispatch>();
    const {ticketId, startCall} = useSelector((state: any) => state.call)
    const intv = React.useRef<any>()

    const message = React.useCallback((event: any) => {
        const data = event.data.data
        if (data.navigationId === 'call' && data.action === 'incoming' && !ticketId) {
            dispatch(setCall({
                ticketId: data.ticketId,
                hasVideo: data.hasVideo === 'true'
            }))
        }
        if (data.navigationId === 'call' && data.action === 'ended' && ticketId.toString()===data.ticketId && !startCall) {
            dispatch(endCall())
        }
    }, [ticketId])

    React.useEffect(() => {
        const channel = new BroadcastChannel('sw-call-messages');
        channel.addEventListener('message', message);
        return () => {
            channel.removeEventListener('message', message)
        }
    }, [message])

    React.useEffect(() => {
        if (!startCall)
            setRing(!!ticketId)
        else if (ticketId) {
            dispatch(generateCallToken())
            setRing(false)
        }
    }, [ticketId, startCall])

    React.useEffect(()=>{
        if(startCall || !ring){
            if(intv.current){
                clearTimeout(intv.current)
            }
        } else if (ring){
            intv.current = setTimeout(()=>{
                setRing(false)
            },60000)
        }
    },[startCall, ring])

    const container = document.getElementById('callContainer')
    let portal = undefined;
    if (startCall)
        portal = <CallScreen/>
    else if (ring) {
        portal = <Ringer/>
    }
    return (
        <>
            {container ? createPortal(portal, container) : <></>}
            {props.children}
        </>
    );
};

export default CallHandler;
